import { Injectable } from '@angular/core';


import { EvkHttpService, EvkUpdateServiceBase } from '@evomatik/evk-common';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RechazarDiligenciaService extends EvkUpdateServiceBase<any> {

  constructor(
      http: EvkHttpService
  ) { 
      super(http);
  }

  evkOnBeforeEdit(data: any): Observable<any> {
    return new Observable(
      (observer) => {
          observer.next(data);
      }
    );
  }
    evkOnDoneEdit(data){
    }
  public evkOnErrorEdit(error: any): void {
  }
  public get api(): string {
    return '/seaged-diligencias-service/diligencia/v2/rechazar';
  }
  
}
